export { PartnershipsAssetsView } from './PartnershipsAssetsView'
